'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useAnalytics = require('use-analytics');
var index = require('./module/index.js');
var index$1 = require('./Analytics/index.js');



Object.defineProperty(exports, 'useAnalytics', {
    enumerable: true,
    get: function () { return useAnalytics.useAnalytics; }
});
exports.PicoAnalyticsModule = index;
exports.PicoAnalytics = index$1.PicoAnalytics;
exports.PicoAnalyticsProvider = index$1.PicoAnalyticsProvider;
//# sourceMappingURL=index.js.map
